import { z } from 'zod';

export const nmiMeterSchema = z.object({
  controlledLoad: z.string(),
  dialFormat: z.string(),
  multiplier: z.string(),
  networkTariffCode: z.string(),
  registerId: z.string(),
  serialNumber: z.string(),
  suffix: z.string(),
  timeOfDay: z.string(),
  unitOfMeasure: z.string(),
  installationTypeCode: z.string(),
});

export type NmiMeterSchema = z.infer<typeof nmiMeterSchema>;
